export default __webpack_public_path__ + "static/media/quotation.88108000.svg";